<template>
  <gas-page-shell :breadcrumb="['设备管理', '项目分类']">
    <div class="search-section">
      <div class="section-title"><span class="title-bar"></span>检索条件</div>
      <el-form :inline="true" :model="query" size="small" label-width="80px" class="search-form">
        <el-form-item label="分类名称">
          <el-input v-model="query.keyword" clearable placeholder="名称/编码/备注" style="width:180px" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" clearable placeholder="全部" style="width:120px">
            <el-option label="已启用" value="0" />
            <el-option label="已停用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-panel">
      <div class="table-toolbar">
        <div class="table-title-group">
          <span class="table-title">项目分类 <em>共 {{ total }} 条记录</em></span>
          <gas-table-toolbar
            :columns="tableColumnDefs"
            :visible-map.sync="tableColumnVisible"
            :selected-count="selectedIds.length"
            :show-batch-delete="tableCanBatchDelete"
            @batch-delete="batchRemove"
          />
        </div>
        <div class="toolbar-actions">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate(emptyForm())">新增分类</el-button>
          <el-button size="small" icon="el-icon-refresh" circle @click="loadData" />
        </div>
      </div>

      <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="44" align="center" />
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="{ $index }">{{ rowNo($index) }}</template>
        </el-table-column>
        <el-table-column prop="categoryName" label="分类名称" min-width="140" />
        <el-table-column prop="categoryCode" label="分类编码" width="120">
          <template slot-scope="{ row }">{{ row.categoryCode || '—' }}</template>
        </el-table-column>
        <el-table-column label="排序号" width="80" align="center">
          <template slot-scope="{ row }">{{ row.sortNo != null ? row.sortNo : 0 }}</template>
        </el-table-column>
        <el-table-column label="状态" width="96" align="center">
          <template slot-scope="{ row }">
            <span class="status-dot" :class="row.status === '0' ? 'on' : 'off'">
              {{ row.status === '0' ? '已启用' : '已停用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="内置" width="72" align="center">
          <template slot-scope="{ row }">{{ row.builtin === 1 ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
        <el-table-column prop="updateTime" label="更新时间" width="160" />
        <el-table-column label="操作" width="140" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" class="op-edit" @click="openEdit(row, emptyForm())">编辑</el-button>
            <el-button type="text" size="small" class="op-del" :disabled="row.builtin === 1" @click="removeRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.pageNum"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" @closed="form = {}">
      <el-form :model="form" label-width="96px" size="small">
        <el-form-item label="分类名称" required>
          <el-input v-model="form.categoryName" placeholder="如 民用项目" />
        </el-form-item>
        <el-form-item label="分类编码">
          <el-input v-model="form.categoryCode" placeholder="可选" />
        </el-form-item>
        <el-form-item label="排序号">
          <el-input v-model.number="form.sortNo" placeholder="数字越小越靠前" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="已启用" value="0" />
            <el-option label="已停用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasCrudPage from '@/mixins/gasCrudPage'
import { gasApi } from '@/api/gas'

const emptyForm = () => ({ categoryName: '', categoryCode: '', sortNo: 0, status: '0', remark: '' })

export default {
  components: { GasPageShell },
  mixins: [gasCrudPage],
  data() {
    return {
      idField: 'categoryId',
      listApi: params => gasApi.projectCategory.list(params),
      saveApi: data => gasApi.projectCategory.save(data),
      removeApi: id => gasApi.projectCategory.remove(id),
      batchRemoveApi: ids => gasApi.projectCategory.batchRemove({ ids }),
      tableColumnDefs: [
        { key: 'categoryName', label: '分类名称' },
        { key: 'categoryCode', label: '分类编码' },
        { key: 'sortNo', label: '排序号' },
        { key: 'status', label: '状态' },
        { key: 'builtin', label: '内置' },
        { key: 'remark', label: '备注' },
        { key: 'updateTime', label: '更新时间' }
      ],
      query: { pageNum: 1, pageSize: 10, keyword: '', status: '' }
    }
  },
  created() {
    this.initTableColumns(this.tableColumnDefs)
  },
  methods: {
    emptyForm,
    rowNo(i) {
      return (this.query.pageNum - 1) * this.query.pageSize + i + 1
    },
    resetSearch() {
      this.resetQuery(() => {
        this.query.status = ''
      })
    },
    async submitForm() {
      if (!this.form.categoryName || !String(this.form.categoryName).trim()) {
        return this.$message.warning('请填写分类名称')
      }
      await gasCrudPage.methods.submitForm.call(this)
    }
  }
}
</script>

<style scoped lang="scss">
.search-section {
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  padding: 16px 16px 4px;
  margin-bottom: 16px;
}
.section-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 12px;
}
.title-bar {
  width: 3px;
  height: 14px;
  background: #1677ff;
  margin-right: 8px;
}
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.status-dot.on { color: #00b42a; }
.status-dot.off { color: #86909c; }
.op-del { color: #f53f3f; }
.pager { margin-top: 16px; text-align: right; }
</style>
